<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div class="text-center" v-show="isLoading">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
          </div>
          <div slot="header">
            ویرایش
            <strong v-text="$lang.company"></strong>
          </div>

          <b-tabs v-show="!isLoading">
            <b-tab :lazy="true" active>
              <template v-slot:title>
                {{ $lang.base_info }}
              </template>

              <editCompanyForm
                v-if="Object.keys(companyItem).length > 0"
                :item="companyItem"
                mode="edit"
                keyServies="company"
                :keyValue="id"
                :showPermissionButton="isAdmin(permission, allowPermissions)"
                @save="save"
                @removeImage="removeImage"
                @uploadClose="uploadClose"
              />
            </b-tab>
            <b-tab :lazy="true" class="p-0">
              <template v-slot:title>
                {{ $lang.contact }}
              </template>

              <Search
                v-if="parentPermissions.length"
                :allowCollapse="false"
                :url="contactUrl"
                :title="$lang.contact_company"
                :allowFields="$lang.contact_fields"
                config="contact"
                addModalSize="lg"
                removeModalSize="xl"
                :visibleSearch="false"
                :visibleSettings="false"
                :visibleExport="false"
                :visibleFilters="false"
                :visibleViewCount="false"
                :allowEdit="false"
                ref="searchContact"
                :dynamicButtons="buttonsSearchContact"
                :parentPermissions="parentPermissions"
              >
                <template slot="addModal" slot-scope="search">
                  <AddContact
                    isModal
                    :entityId="id"
                    :parentPermissions="parentPermissions"
                    entity="company"
                    @modal-end-up="search.close"
                    @getItems="getContactItems"
                  />
                </template>
              </Search>
              <b-modal
                no-close-on-backdrop
                variant="primary"
                header-bg-variant="primary"
                content-class="border-primary"
                v-model="view_edit_contact"
                size="xl"
                ok-only
                hide-footer
                hide-header
              >
                <EditContact
                  :isModal="true"
                  :contactId="contact_id"
                  entity="company"
                  :entityId="id"
                  :parentPermissions="parentPermissions"
                  @modal-end-up="closeEditContact"
                  @getItems="getContactItems"
                />
              </b-modal>
            </b-tab>
            <b-tab :lazy="true" class="p-0">
              <template v-slot:title>
                {{ $lang.address }}
              </template>
              <Search
                v-if="parentPermissions.length"
                :allowCollapse="false"
                :url="addressUrl"
                :title="$lang.address_company"
                :allowFields="$lang.address_fields"
                config="address"
                addModalSize="lg"
                removeModalSize="xl"
                :visibleSearch="false"
                :visibleSettings="false"
                :visibleExport="false"
                :visibleFilters="false"
                :visibleViewCount="false"
                :allowEdit="false"
                ref="searchAddress"
                :dynamicButtons="buttons"
                :parentPermissions="parentPermissions"
              >
                <template slot="addModal" slot-scope="search">
                  <AddAddress
                    isModal
                    :entityId="id"
                    :parentPermissions="parentPermissions"
                    entity="company"
                    @modal-end-up="search.close"
                    @getItems="getAddressItems"
                  />
                </template>
              </Search>
              <b-modal
                no-close-on-backdrop
                variant="primary"
                header-bg-variant="primary"
                content-class="border-primary"
                v-model="view_edit_address"
                size="xl"
                ok-only
                hide-footer
                hide-header
              >
                <EditAddress
                  :isModal="true"
                  :addressId="address_id"
                  :entityId="id"
                  entity="company"
                  :parentPermissions="parentPermissions"
                  @modal-end-up="closeEditAddress"
                  @getItems="getAddressItems"
                />
              </b-modal>
            </b-tab>
            <b-tab :lazy="true" class="p-0">
              <template v-slot:title>
                {{ $lang.attachments }}
              </template>
              <UploadFile
                :crop="false"
                attachment_type_name="attachment_type_company"
                attachmentRoute="attachment_company"
                :outParams="{ attachment_type_id: [42, 43, 44] }"
                keyServies="company"
                :keyValue="id"
                :file_types="file_types"
                :parentPermissions="parentPermissions"
                :hasEditTypeAttachment="true"
                :propAttachmentType="true"
                :parent_attachment_type_options="attachment_type_options"
              />
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
      <Confirm
        :title="modalTitle"
        :description="message"
        v-model="confirmModal"
        :ok-title="$lang.yes"
        :cancel-title="$lang.no"
        :loading="confirmLoading"
        dynamicClass=""
        @ok="okConfim"
        @cancel="cancelConfim"
      />
    </b-row>
  </div>
</template>

<script>
import Confirm from "@/components/base/confirm";
import Search from "@/components/base/search";
import AddAddress from "../address/addAddress";
import EditAddress from "../address/editAddress";
import AddContact from "../contact/addContact";
import EditContact from "../contact/editContact";
import UploadFile from "@/components/base/uploadFile";
import EditCompanyForm from "./../forms/editCompanyForm";
import { pathOr } from "ramda";
import { generateApiUrl, isAdmin, renderEumOptions } from "@/shared/utils";

export default {
  name: "edit-company",
  inject: ["attachmentRepository"],
  components: {
    Search,
    AddAddress,
    AddContact,
    EditAddress,
    EditContact,
    UploadFile,
    Confirm,
    EditCompanyForm,
  },
  props: {
    backUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      file_types: ["image", "office", "media", "other"],
      id: this.$route.params.id,
      confirmModal: false, // بازکردن مدال کانفرم
      modalTitle: "", // عنوان مدال
      message: "", // نمایش متن حذف فایل
      permission: [],
      companyItem: {},
      allowPermissions: ["admin", "edit"],
      isLoading: true,
      errors: [],
      view_edit_address: false,
      view_edit_contact: false,
      address_id: "",
      contact_id: "",
      parentPermissions: [],
      buttons: [
        {
          id: "0",
          name: "edit",
          click: this.changeAddress,
        },
        {
          id: "1",
          name: "view",
          click: this.changeAddress,
        },

        {
          id: "3",
          name: "delete",
        },
      ],
      buttonsSearchContact: [
        {
          id: "0",
          name: "edit",
          click: this.changeContact,
        },
        {
          id: "1",
          name: "view",
          click: this.changeContact,
        },

        {
          id: "3",
          name: "delete",
        },
      ],
      confirmLoading: false,
    };
  },
  computed: {
    addressUrl() {
      return generateApiUrl(["resources", "company_address"], [this.id]);
    },
    contactUrl() {
      return generateApiUrl(["resources", "company_contact"], [this.id]);
    },
    attachment_type_options() {
      return renderEumOptions("attachment_type_company");
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    generateApiUrl,
    isAdmin,
    renderEumOptions,
    async uploadClose() {
      this.isLoading = true;
      await this.fetchData();
      this.isLoading = false;
    },
    /**
     * @vuese
     * پاک کردن پیغام تایید پاک کردن
     *  @arg  بدون پارامتر
     */
    clearModalConfirm() {
      this.modalTitle = "";
    },
    /**
     * @vuese
     * قبول کردن فایل حذف شود
     *  @arg  بدون پارامتر
     */
    async okConfim() {
      let pic = this.companyItem.images_kind.find((x) => x.type == "thumb");
      if (pic) {
        try {
          this.confirmLoading = true;
          let payload = {
            is_default: 0,
          };
          let keyServies = "company";
          let keyValue = this.$route.params.id;
          const response = await this.attachmentRepository.partial_edit(
            pic.id,
            payload,
            keyServies,
            keyValue
          );
          this.uploadClose();
          this.$notify.success(response.data.message);
        } catch (error) {
          this.$generateError(error);
        } finally {
          this.showFileList = false;
          this.confirmLoading = false;
        }
      }
      this.clearModalConfirm();
    },
    /**
     * @vuese
     * لغو کردن فایل حذف شود
     *  @arg  بدون پارامتر
     */
    cancelConfim() {
      this.confirmModal = false;
      this.clearModalConfirm();
    },
    removeImage() {
      this.message = this.$lang.are_you_sure;
      this.modalTitle = this.$lang.remove_item;
      this.confirmModal = true;
    },
    closeEditContact() {
      this.view_edit_contact = false;
      this.getContactItems();
      this.contact_id = "";
    },
    changeContact(item) {
      this.contact_id = item.id.toString();
      this.view_edit_contact = true;
    },
    getContactItems() {
      this.$refs.searchContact.getItems();
    },
    getAddressItems() {
      this.$refs.searchAddress.getItems();
    },
    closeEditAddress() {
      this.view_edit_address = false;
      this.getAddressItems();
      this.address_id = "";
    },
    changeAddress(item) {
      this.address_id = item.id.toString();
      this.view_edit_address = true;
    },
    clear() {
      this.name = "";
      this.description = "";
      this.category_selected = null;
      this.exercise_selected = null;
    },
    afterSave() {
      if (this.backUrl) {
        this.$router.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    async save(payload) {
      try {
        this.isLoading = true;
        const url = generateApiUrl(["resources", "company_id"], [this.id]);
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
        this.afterSave();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchData() {
      try {
        this.isLoading = true;
        const url = generateApiUrl(["resources", "company_id"], [this.id]);
        const response = await this.$httpService.get(url);
        this.companyItem = pathOr([], ["data", "data"], response);
        this.permission = response.data.permissions;
        this.parentPermissions = response.data.permissions;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
